import { z } from 'zod';
// Currency Format
export var BudgetCurrency;
(function (BudgetCurrency) {
    BudgetCurrency["AED"] = "AED";
    BudgetCurrency["ARS"] = "ARS";
    BudgetCurrency["AUD"] = "AUD";
    BudgetCurrency["BRL"] = "BRL";
    BudgetCurrency["CAD"] = "CAD";
    BudgetCurrency["CHF"] = "CHF";
    BudgetCurrency["CNY"] = "CNY";
    BudgetCurrency["CZK"] = "CZK";
    BudgetCurrency["DKK"] = "DKK";
    BudgetCurrency["EUR"] = "EUR";
    BudgetCurrency["GBP"] = "GBP";
    BudgetCurrency["HKD"] = "HKD";
    BudgetCurrency["KES"] = "KES";
    BudgetCurrency["INR"] = "INR";
    BudgetCurrency["JMD"] = "JMD";
    BudgetCurrency["JPY"] = "JPY";
    BudgetCurrency["LAK"] = "LAK";
    BudgetCurrency["MXN"] = "MXN";
    BudgetCurrency["MYR"] = "MYR";
    BudgetCurrency["NOK"] = "NOK";
    BudgetCurrency["NONE"] = "NONE";
    BudgetCurrency["PHP"] = "PHP";
    BudgetCurrency["PLN"] = "PLN";
    BudgetCurrency["RON"] = "RON";
    BudgetCurrency["RUB"] = "RUB";
    BudgetCurrency["SGD"] = "SGD";
    BudgetCurrency["THB"] = "THB";
    BudgetCurrency["TTD"] = "TTD";
    BudgetCurrency["UAH"] = "UAH";
    BudgetCurrency["USD"] = "USD";
})(BudgetCurrency || (BudgetCurrency = {}));
// Currency symbols mapping
export const CURRENCY_SYMBOLS = {
    [BudgetCurrency.AED]: 'د.إ',
    [BudgetCurrency.ARS]: '$',
    [BudgetCurrency.AUD]: '$',
    [BudgetCurrency.BRL]: 'R$',
    [BudgetCurrency.CAD]: '$',
    [BudgetCurrency.CHF]: 'CHF',
    [BudgetCurrency.CNY]: '¥',
    [BudgetCurrency.CZK]: 'Kč',
    [BudgetCurrency.DKK]: 'kr',
    [BudgetCurrency.EUR]: '€',
    [BudgetCurrency.GBP]: '£',
    [BudgetCurrency.HKD]: 'HK$',
    [BudgetCurrency.INR]: '₹',
    [BudgetCurrency.JMD]: 'J$',
    [BudgetCurrency.JPY]: '¥',
    [BudgetCurrency.KES]: 'KSh',
    [BudgetCurrency.LAK]: '₭',
    [BudgetCurrency.MXN]: '$',
    [BudgetCurrency.MYR]: 'RM',
    [BudgetCurrency.NOK]: 'kr',
    [BudgetCurrency.NONE]: '',
    [BudgetCurrency.PHP]: '₱',
    [BudgetCurrency.PLN]: 'zł',
    [BudgetCurrency.RON]: 'lei',
    [BudgetCurrency.RUB]: '₽',
    [BudgetCurrency.SGD]: 'S$',
    [BudgetCurrency.THB]: '฿',
    [BudgetCurrency.TTD]: 'TT$',
    [BudgetCurrency.UAH]: '₴',
    [BudgetCurrency.USD]: '$',
};
// Currency display names
export const CURRENCY_NAMES = {
    [BudgetCurrency.NONE]: 'No Currency',
    [BudgetCurrency.AED]: 'UAE Dirham',
    [BudgetCurrency.ARS]: 'Argentine Peso',
    [BudgetCurrency.AUD]: 'Australian Dollar',
    [BudgetCurrency.BRL]: 'Brazilian Real',
    [BudgetCurrency.CAD]: 'Canadian Dollar',
    [BudgetCurrency.CHF]: 'Swiss Franc',
    [BudgetCurrency.CNY]: 'Chinese Yuan',
    [BudgetCurrency.CZK]: 'Czech Koruna',
    [BudgetCurrency.DKK]: 'Danish Krone',
    [BudgetCurrency.EUR]: 'Euro',
    [BudgetCurrency.GBP]: 'British Pound',
    [BudgetCurrency.HKD]: 'Hong Kong Dollar',
    [BudgetCurrency.KES]: 'Kenyan Shilling',
    [BudgetCurrency.INR]: 'Indian Rupee',
    [BudgetCurrency.JMD]: 'Jamaican Dollar',
    [BudgetCurrency.JPY]: 'Japanese Yen',
    [BudgetCurrency.LAK]: 'Lao Kip',
    [BudgetCurrency.MXN]: 'Mexican Peso',
    [BudgetCurrency.MYR]: 'Malaysian Ringgit',
    [BudgetCurrency.NOK]: 'Norwegian Krone',
    [BudgetCurrency.PHP]: 'Filipino Peso',
    [BudgetCurrency.PLN]: 'Polish Złoty',
    [BudgetCurrency.RON]: 'Romanian Leu',
    [BudgetCurrency.RUB]: 'Russian Ruble',
    [BudgetCurrency.SGD]: 'Singapore Dollar',
    [BudgetCurrency.THB]: 'Thai Baht',
    [BudgetCurrency.TTD]: 'Trinidad and Tobago Dollar',
    [BudgetCurrency.UAH]: 'Ukrainian Hryvnia',
    [BudgetCurrency.USD]: 'US Dollar',
};
export const budgetCurrencySchema = z.nativeEnum(BudgetCurrency);
export const budgetCurrencySelectOptions = [
    { value: BudgetCurrency.NONE, label: 'No Currency' },
    { value: BudgetCurrency.AED, label: 'AED - UAE Dirham' },
    { value: BudgetCurrency.ARS, label: 'ARS - Argentine Peso' },
    { value: BudgetCurrency.AUD, label: 'AUD - Australian Dollar' },
    { value: BudgetCurrency.BRL, label: 'BRL - Brazilian Real' },
    { value: BudgetCurrency.CAD, label: 'CAD - Canadian Dollar' },
    { value: BudgetCurrency.CHF, label: 'CHF - Swiss Franc' },
    { value: BudgetCurrency.CNY, label: 'CNY - Chinese Yuan' },
    { value: BudgetCurrency.CZK, label: 'CZK - Czech Koruna' },
    { value: BudgetCurrency.DKK, label: 'DKK - Danish Krone' },
    { value: BudgetCurrency.EUR, label: 'EUR - Euro' },
    { value: BudgetCurrency.GBP, label: 'GBP - British Pound' },
    { value: BudgetCurrency.HKD, label: 'HKD - Hong Kong Dollar' },
    { value: BudgetCurrency.KES, label: 'KES - Kenyan Shilling' },
    { value: BudgetCurrency.INR, label: 'INR - Indian Rupee' },
    { value: BudgetCurrency.JMD, label: 'JMD - Jamaican Dollar' },
    { value: BudgetCurrency.JPY, label: 'JPY - Japanese Yen' },
    { value: BudgetCurrency.LAK, label: 'LAK - Lao Kip' },
    { value: BudgetCurrency.MXN, label: 'MXN - Mexican Peso' },
    { value: BudgetCurrency.MYR, label: 'MYR - Malaysian Ringgit' },
    { value: BudgetCurrency.NOK, label: 'NOK - Norwegian Krone' },
    { value: BudgetCurrency.PHP, label: 'PHP - Filipino Peso' },
    { value: BudgetCurrency.PLN, label: 'PLN - Polish Złoty' },
    { value: BudgetCurrency.RON, label: 'RON - Romanian Leu' },
    { value: BudgetCurrency.RUB, label: 'RUB - Russian Ruble' },
    { value: BudgetCurrency.SGD, label: 'SGD - Singapore Dollar' },
    { value: BudgetCurrency.THB, label: 'THB - Thai Baht' },
    { value: BudgetCurrency.TTD, label: 'TTD - Trinidad and Tobago Dollar' },
    { value: BudgetCurrency.UAH, label: 'UAH - Ukrainian Hryvnia' },
    { value: BudgetCurrency.USD, label: 'USD - US Dollar' },
];
